import { is } from '@common/is/is'
import { getTransById } from '@common/i18n/v1/translate'

import Text from '@common/components/Text/Text'

import { navigator } from '../../navigator'

import styles from './Button.scss'

const TOO_LONG_TEXT_LENGTH = 15

export default class Button extends HTMLElement {
  public set disabled (isDisabled: boolean) {
    if (isDisabled) {
      this.setAttribute('disabled', '')
    }
    else {
      this.removeAttribute('disabled')
    }
  }

  public get disabled (): boolean {
    return this.hasAttribute('disabled')
  }

  public connectedCallback (): void {
    const rest = this.hasAttribute('replace') ? { replace: this.getAttribute('replace') ?? '' } : {}
    const key  = this.getAttribute('key') ?? ''
    const fontClass = getTransById(key).length > TOO_LONG_TEXT_LENGTH ? styles.long : styles.normal

    this.appendChild(
      <Fragment>
        <div className={ styles.icon } />

        <div className={ fontClass }>
          <Text.instance key={ key } { ...rest } />
        </div>
      </Fragment>
    )

    if (this.hasAttribute('action')) {
      this.addEventListener('click', this.onClick)
    }
  }

  /** Click eseményfigyelő lekötése. */
  public disconnectedCallback (): void {
    this.removeEventListener('click', this.onClick)
  }

  /**
   * A gombra kattintás callback.
   * @param e - A klikk esemény.
   */
  private readonly onClick = (e: Event): void => {
    e.preventDefault()

    if (!this.disabled) {
      const action = (this.getAttribute('action') ?? '') as keyof typeof navigator
      const func = navigator[action]

      if (is.function(func)) {
        func()
      }
    }
  }
}

customElements.define('a-button', Button)
